// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__F+9tz","ring":"style_ring__mzRZP","lds-ring":"style_lds-ring__-vLMs"};